import storejs from 'storejs'
import axios from 'axios'
import $req from '../lib/requests'
import pinyin from 'js-pinyin'

/**
 * 针对区号列表进行排序
 * @param {Array} list 元数据
 */
const sortAreaList = list => {
    let charObj = {};
    let result = []

    //以A.B.C...来归并数组到对象中
    list.forEach(item => {
        //中文转全拼
        let fullChar = pinyin.getFullChars(item.name);
        //获取首字符
        let firstChar = fullChar.charAt(0).toLowerCase();

        //如果不存在则创建首字符对应的数组
        if (!charObj[firstChar]) {
            charObj[firstChar] = [];
        }
        charObj[firstChar].push(item)
    })

    //字母排序
    let charObjKeys = Object.keys(charObj);
    charObjKeys.sort();

    charObjKeys.forEach(item => {
        result.push(...charObj[item]);
    })
    return result;
}

const user = {
    state: {
        token: storejs.get('user_token'),
        nextRoute: storejs.get('nextRoute') || {},
        hotList: storejs.get('recomandCitys') || [], //热门城市列表
        historyCityList: storejs.get('historyList') || [], //历史搜索记录
        countryList: storejs.get('country') || [],  //国家地区区号等
        country: storejs.get('area') || '',         //用户所选的国家/地区如CN
        avatar: storejs.get('avatar'), //头像
        showLogin: false, //是否显示登录框
        showCountry: false,  //是否显示国籍选择框
        forgetFlow: {
            show: false, //是否显示忘记密码框
            type: 'email' //决定显示内容，分别有email/mobile/password
        },
        showSignup: false, //是否显示注册框
        user: storejs.get('user') || {}
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            storejs.set('user_token', token);
            if (!token) {
                /* 用户退出登录 */
                localStorage.removeItem('user_token');
                localStorage.removeItem('user');
                localStorage.removeItem('avatar');
                delete axios.defaults.headers.common["user-token"]
                delete axios.defaults.headers.common["user-id"]
                storejs.remove('expireTime');
                gtag('set', {
                    user_id: ''
                })
            } else {
                /* 用户登录 */
                //记录登录时时间戳
                storejs.set('expireTime', Date.now());
                //全局设置埋点用户
                gtag('set', {
                    user_id: state.user.user_id
                })
            }
            state.token = token;
        },
        SET_USER: (state, user) => {
            state.user = user;
            storejs.set('user', user);
        },
        SET_AVATAR: (state, avatar) => {
            if (avatar) {
                let hasProtocal = avatar.indexOf('http') > -1;
                avatar = hasProtocal ? avatar : '//' + avatar
                storejs.set('avatar', avatar);
                state.avatar = avatar;
            } else {
                state.avatar = null;
            }
        },
        SET_SHOW_LOGIN: (state, isShow) => {
            state.showLogin = isShow;
            if (isShow) {
                state.showSignup = false;
            }
        },
        SET_SHOW_SIGNUP: (state, isShow) => {
            state.showSignup = isShow;
            if (isShow) {
                state.showLogin = false;
            }
        },
        SET_FORGET_FLOW: (state, flow) => {
            state.forgetFlow = flow;
            if (flow.show) {
                state.showLogin = false;
            }
        },
        SET_HOT_LIST: (state, list) => {
            storejs.set('recomandCitys', list);
            state.hotList = list;
        },
        SET_HISTORY_CITY_LIST: (state, city) => {
            const MAX = 5;
            let list = state.historyCityList;
            for (let item of list) {
                //城市名是否相同
                if (item.cityName === city.cityName) {
                    //酒店id存在且存在当前列表中
                    if (city.hotelItemCode != null && city.hotelItemCode === item.hotelItemCode) {
                        return
                    }
                }
            }
            if (list.length >= MAX) {
                list.shift();
                list.push(city)
            } else {
                list.push(city);
            }
            storejs.set('historyList', list);
            state.historyCityList = list;
        },
        CLEAR_HISTORY_CITY_LIST: state => {
            storejs.set('historyList', []);
            state.historyCityList = [];
        },
        SET_COUNTRY_LIST: (state, list) => {
            let lang = storejs.get('lang');
            let isCn = lang === 'zh-CN' || lang === 'zh-HK';
            if (isCn) {
                //按照中文排序
                list = sortAreaList(list)
            }
            storejs.set('country', list);
            state.countryList = list
        },
        SET_COUNTRY: (state, country) => {
            storejs.set('area', country);
            state.country = country;
        },
        SET_SHOW_COUNTRY: (state, isShow) => {
            state.showCountry = isShow;
        },
        SET_NEXT_ROUTE: (state, nextRoute) => {
            state.nextRoute = nextRoute;
            storejs.set('nextRoute', nextRoute)
        }
    },
    actions: {
        updateToken({ commit }, token) {
            commit('SET_TOKEN', token);
        },
        updateUser({ commit }, user) {
            commit('SET_USER', user);
        },
        updateAvatar({ commit }, avatar) {
            commit('SET_AVATAR', avatar);
        },
        toggleShowLogin({ commit, dispatch }, isShow) {
            commit('SET_SHOW_LOGIN', isShow)
            dispatch('updateCountryList')
        },
        toggleShowSignup({ commit }, isShow) {
            commit('SET_SHOW_SIGNUP', isShow);
        },
        updateForgetFlow({ commit }, flow) {
            commit('SET_FORGET_FLOW', flow);
        },
        updateHotList({ commit }, list) {
            commit('SET_HOT_LIST', list);
        },
        updateHistoryCityList({ commit }, city) {
            commit('SET_HISTORY_CITY_LIST', city);
        },
        clearHistoryCityList({ commit }) {
            commit('CLEAR_HISTORY_CITY_LIST');
        },
        updateCountryList({ commit }, isChange = false) {
            let countryList = storejs.get('country');
            return new Promise((resolve, reject) => {
                if (countryList && !isChange) {
                    resolve()
                } else {
                    $req.get('getcountry', {}).then(({ data }) => {
                        commit('SET_COUNTRY_LIST', data.data);
                        resolve()
                    }).catch(() => {
                        reject()
                    })
                }
            })
        },
        updateCountry({ commit }, country) {
            //更新用户当前的国家/区域，默认为美国地区
            commit('SET_COUNTRY', country || 'US');
        },
        toggleShowCountry({ commit }, isShow) {
            commit('SET_SHOW_COUNTRY', isShow)
        },
        setNextRoute({ commit }, nextRoute) {
            commit('SET_NEXT_ROUTE', nextRoute);
        }
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/user.js